import type {
  DocumentKind,
  RiskSignal,
  RiskSignalGroupKind,
  SignalSeverity,
} from '@onefootprint/request-types/dashboard';

export type RiskSignalSection = {
  key: string;
  group: RiskSignalGroupKind;
  documentKind?: DocumentKind;
  signals: RiskSignal[];
};

// Groups risk signals by group, sorted by severity. `doc` splits further by document: a playbook
// may collect several, and all of their signals share the one group.
const groupRiskSignals = (riskSignals: RiskSignal[]): RiskSignalSection[] => {
  const severityOrder: Record<SignalSeverity, number> = {
    high: 0,
    medium: 1,
    low: 2,
    info: 3,
  };
  const sections = new Map<string, RiskSignalSection>();

  riskSignals.forEach(signal => {
    const key = `${signal.group}:${signal.documentKind ?? ''}`;
    let section = sections.get(key);
    if (!section) {
      section = { key, group: signal.group, documentKind: signal.documentKind, signals: [] };
      sections.set(key, section);
    }
    section.signals.push(signal);
  });

  const result = Array.from(sections.values());
  result.forEach(({ signals }) => {
    signals.sort((a, b) => severityOrder[a.severity] - severityOrder[b.severity]);
  });

  return result;
};

export default groupRiskSignals;
